// Простой провайдер цен для торговой панели
class PriceProvider {
  static simulatedPrices = {
    // Валютные пары (FX) - доступны в TradingView
    'EURUSD': 1.11460,
    'GBPUSD': 1.29500,
    'USDJPY': 143.21,
    'USDCHF': 0.86500,
    'AUDUSD': 0.67200,
    
    // Криптовалюты (Binance) - доступны в TradingView
    'BTCUSD': 67500,
    'ETHUSD': 2534,
    
    // Товары (TVC) - доступны в TradingView
    'XAUUSD': 2670.50,   // Золото
    'XAGUSD': 31.20,     // Серебро
    'WTIUSD': 75.85,     // Нефть WTI
    
    // Акции (NASDAQ) - доступны в TradingView
    'AAPL': 227.50,
    'TSLA': 248.30,
    'GOOGL': 167.20,
    'MSFT': 415.85,
    
    // Индексы (TVC) - доступны в TradingView
    'SPX500': 5751.20,
    'NASDAQ': 18137.85
  };

  static priceCache = new Map();
  static lastUpdate = new Map();

  // Получить текущую цену актива
  static getCurrentPrice(asset) {
    const basePrice = this.simulatedPrices[asset] || 100;
    const now = Date.now();
    const lastUpdateTime = this.lastUpdate.get(asset) || 0;
    
    // Обновляем цену каждые 3 секунды
    if (now - lastUpdateTime > 3000) {
      // Генерируем реалистичное движение цены
      const volatility = this.getVolatility(asset);
      const cached = this.priceCache.get(asset) || basePrice;
      const priceChange = (Math.random() - 0.5) * volatility * cached;
      const newPrice = Math.max(cached + priceChange, cached * 0.99);
      
      this.priceCache.set(asset, newPrice);
      this.lastUpdate.set(asset, now);
      
      return parseFloat(newPrice.toFixed(this.getPrecision(asset)));
    }
    
    return this.priceCache.get(asset) || basePrice;
  }

  // Получить волатильность для актива
  static getVolatility(asset) {
    const volatilityMap = {
      // Валютные пары - низкая волатильность
      'EURUSD': 0.0002, 'GBPUSD': 0.0003, 'USDJPY': 0.002,
      'USDCHF': 0.0002, 'AUDUSD': 0.0003,
      
      // Криптовалюты - высокая волатильность  
      'BTCUSD': 0.01, 'ETHUSD': 0.012,
      
      // Товары - средняя волатильность
      'XAUUSD': 0.005, 'XAGUSD': 0.008, 'WTIUSD': 0.01,
      
      // Акции - средняя волатильность
      'AAPL': 0.008, 'TSLA': 0.012, 'GOOGL': 0.01, 'MSFT': 0.007,
      
      // Индексы - низкая волатильность
      'SPX500': 0.005, 'NASDAQ': 0.007
    };
    
    return volatilityMap[asset] || 0.005;
  }

  // Получить точность (количество знаков после запятой)
  static getPrecision(asset) {
    if (asset.includes('JPY')) return 3;
    if (asset.includes('USD') && !asset.includes('BTC') && !asset.includes('ETH')) return 5;
    if (asset.includes('BTC') || asset.includes('ETH')) return 2;
    if (asset === 'XAUUSD' || asset === 'XAGUSD') return 2;
    return 2;
  }

  // Получить форматированную цену
  static getFormattedPrice(asset) {
    const price = this.getCurrentPrice(asset);
    const precision = this.getPrecision(asset);
    return price.toFixed(precision);
  }

  // Начать обновление цен в реальном времени
  static startPriceUpdates(callback, interval = 3000) {
    return setInterval(() => {
      const assets = Object.keys(this.simulatedPrices);
      assets.forEach(asset => {
        const price = this.getCurrentPrice(asset);
        if (callback) {
          callback(asset, price);
        }
      });
    }, interval);
  }

  // Остановить обновление цен
  static stopPriceUpdates(intervalId) {
    if (intervalId) {
      clearInterval(intervalId);
    }
  }
}

export default PriceProvider;